import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { fetchUserData } from "storage/sessionStorage";

const PrivateRoutes = ({ component: Component, ...rest }) => {
	const { accessToken } = fetchUserData();

	return (
		<Route
			{...rest}
			render={(props) =>
				accessToken ? (
					<Component {...props} />
				) : (
					<Redirect to="/auth/login" />
				)
			}
		/>
	);
};

export default withRouter(PrivateRoutes);
